import classNames from "classnames";
import { FC } from "react";
import BillingsCargoOrderListingItemBillingStatus from "../../types/billings-cargo-order-listing-item-billing-status";

type BillingsCargoOrderTableStatusProps = {
  status: BillingsCargoOrderListingItemBillingStatus | undefined;
};

const BillingsCargoOrderListingTableStatusComponent: FC<
  BillingsCargoOrderTableStatusProps
> = (props) => {
  const getClassnameByStatus = (): string => {
    switch (props.status) {
      case BillingsCargoOrderListingItemBillingStatus.CREATED:
        return "created";
      case BillingsCargoOrderListingItemBillingStatus.ACCEPTED:
        return "accepted";
      case BillingsCargoOrderListingItemBillingStatus.REJECTED:
        return "rejected";
      case BillingsCargoOrderListingItemBillingStatus.REOPENED:
        return "reopened";
      case BillingsCargoOrderListingItemBillingStatus.REOPEN_REQUEST_SENT:
        return "reopen_request_sent";
      default:
        return "";
    }
  };

  const statusClassname = getClassnameByStatus();

  const containerClassNames = classNames(
    "billings_cargo_order_listing_table_status",
    statusClassname,
  );

  return <div className={containerClassNames}></div>;
};

export default BillingsCargoOrderListingTableStatusComponent;
